import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts';
import router from "../router";
import store from "../store";
/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */

export var asyncRouterMap = [{
  path: '*',
  redirect: '/404',
  hidden: true
}];
/**
 * 基础路由
 * @type { *[] }
 */

export var constantRouterMap = [{
  path: '/user',
  component: UserLayout,
  redirect: '/user/login',
  hidden: true,
  children: [{
    path: 'login',
    name: 'login',
    component: function component() {
      try {
        var tenantCode = window.localStorage.getItem('projectCode'); //如果存在租户定制化页面则进入租户定制化页面

        return Promise.resolve(require('@/views/tenant/' + tenantCode + '/user/loginPage').default);
      } catch (e) {
        //报错说明租户定制化页面不存在，进入菜单配置界面
        return Promise.resolve(require('@/views/user/loginPage').default);
      }
    }
  }]
}, {
  path: '/ds',
  component: BlankLayout,
  redirect: '/ds/index',
  hidden: true,
  children: [{
    path: 'index',
    name: 'index',
    component: function component() {
      try {
        var tenantCode = window.localStorage.getItem('projectCode'); //如果存在租户定制化页面则进入租户定制化页面

        return Promise.resolve(require('@/views/tenant/' + tenantCode + '/dashboard/index').default);
      } catch (e) {
        //报错说明租户定制化页面不存在，进入菜单配置界面
        return Promise.resolve(require('@/views/dashboard/index').default);
      }
    }
  }, {
    path: 'siteindex',
    name: 'siteindex',
    component: function component() {
      return import('@/views/tenant/sx/dashboard/siteindex');
    }
  }, {
    path: 'view',
    name: 'view',
    component: function component() {
      return import('@/views/tenant/qd/dashboard/index');
    }
  }, {
    path: 'statistics',
    name: 'statistics',
    component: function component() {
      return import('@/views/tenant/jx/dashboard/index');
    }
  }, {
    path: 'energy',
    name: 'energy',
    component: function component() {
      return import('@/views/tenant/zhny/dashboard/index');
    }
  }, {
    path: 'pollute',
    name: 'pollute',
    component: function component() {
      return import('@/views/tenant/nymywr/dashboard/index');
    }
  }]
}, {
  path: '/user',
  component: BlankLayout,
  redirect: '/user/bindWechat',
  hidden: true,
  children: [{
    path: 'bindWechat',
    name: 'bindWechat',
    component: function component() {
      return import('@/views/user/BindUserWechat');
    }
  }]
}, {
  path: '/visualPreview/:id',
  name: 'visualPreview',
  component: function component() {
    return import('@/views/visual/dataScreen/view');
  }
}, {
  path: '/visual/build/:id',
  name: 'build',
  component: function component() {
    return import('@/views/visual/dataScreen/build');
  }
}, {
  path: '/app',
  component: BlankLayout,
  hidden: true,
  children: [{
    path: 'swsk',
    name: 'swsk',
    hidden: true,
    component: BlankLayout,
    children: [{
      path: 'dashboard',
      name: 'swskDashboard',
      component: function component() {
        return import('@/views/tenant/swsk/app/dashboard');
      }
    }, {
      path: 'map',
      name: 'map',
      component: function component() {
        return import('@/views/tenant/swsk/app/map');
      }
    }]
  }]
}, // {
//   path: '/visual',
//   component: BlankLayout,
//   redirect: '/visual',
//   hidden: true,
//   children: [
//     {
//       path: 'build/:id',
//       name: 'build',
//       component: () => import('@/views/visual/dataScreen/build')
//     },
// 	{
// 	  path: 'preview/:id',
// 	  name: 'preview',
// 	  component: () => import('@/views/visual/dataScreen/view')
// 	}
//   ]
// },
{
  path: '/404',
  component: function component() {
    return import(
    /* webpackChunkName: "fail" */
    '@/views/exception/404');
  }
}];